import * as React from 'react';
import * as moment from 'moment-timezone';
import { InlineChildren, InlineChildrenAlignment, InlineChildrenSize, Inset, InsetSize, StackChildren, Text, Colors, } from '@doordash/design-language';
import { TileContainer, DayTitleText, NewOrderButton, GoEntriesContainer, NewOrderButtonWrapper, } from './CalendarStyles';
import Separator, { SeparatorType } from '@doordash/component-separator';
import GroupOrderEntry from '../GroupOrderEntry/GroupOrderEntry';
import { useCalendarViewContext } from './CalendarViewContext';
import GroupOrdersCalendarStrings from '../../GroupOrdersCalendarStrings';
var DEFAULT_NEW_ORDER_END_TIME = '20:30:00'; // 8:30PM i.e. 1hr 20 mins before the last delivery time
var CalendarTile = function (_a) {
    var officeCurrentDateTime = _a.officeCurrentDateTime, dateInfo = _a.dateInfo, goEntries = _a.goEntries, onNewOrderClick = _a.onNewOrderClick, onDeleteEntry = _a.onDeleteEntry;
    var isEmployeeView = useCalendarViewContext().isEmployeeView;
    var officeCurrentDate = officeCurrentDateTime.date, officeCurrentTime = officeCurrentDateTime.time;
    var isCurrentDate = officeCurrentDate === dateInfo.formattedDate;
    var isAfterCurrentDayNewOrderEndTime = isCurrentDate &&
        moment(officeCurrentDate + " " + officeCurrentTime).isAfter(dateInfo.formattedDate + " " + DEFAULT_NEW_ORDER_END_TIME);
    var shouldShowNewOrderBtn = moment(officeCurrentDate).isSameOrBefore(dateInfo.formattedDate) &&
        !isAfterCurrentDayNewOrderEndTime &&
        Boolean(onNewOrderClick);
    var entries = goEntries === null || goEntries === void 0 ? void 0 : goEntries.entries;
    return (React.createElement(TileContainer, null,
        React.createElement(Inset, { size: InsetSize.XSmall },
            React.createElement(InlineChildren, { size: InlineChildrenSize.XSmall, alignItems: InlineChildrenAlignment.Center },
                React.createElement(DayTitleText, { shouldMarkDate: isCurrentDate, color: Colors.TextSecondary }, dateInfo.day),
                React.createElement(Text, { styles: Text.Styles.Label2Emphasis, color: Colors.TextSecondary }, dateInfo.weekdayName))),
        React.createElement(Separator, { type: SeparatorType.FullBorder }),
        React.createElement(GoEntriesContainer, null,
            React.createElement(StackChildren, { size: StackChildren.Sizes.XSmall },
                !isEmployeeView && (React.createElement(NewOrderButtonWrapper, { visibility: shouldShowNewOrderBtn },
                    React.createElement(NewOrderButton, { children: GroupOrdersCalendarStrings.newOrderButton(), onClick: function () { return onNewOrderClick(dateInfo.formattedDate); } }))),
                entries &&
                    Array.isArray(entries) &&
                    entries.map(function (entry) {
                        if (entry) {
                            return (React.createElement(GroupOrderEntry, { key: "go-entry-" + entry.id + "}", officeCurrentDateTime: officeCurrentDateTime, entry: entry, onDeleteEntry: onDeleteEntry }));
                        }
                        return null;
                    })))));
};
export default CalendarTile;
